import { render, staticRenderFns } from "./CompraPedidoPdf.vue?vue&type=template&id=5bda32bc&"
import script from "./CompraPedidoPdf.vue?vue&type=script&lang=js&"
export * from "./CompraPedidoPdf.vue?vue&type=script&lang=js&"
import style0 from "./CompraPedidoPdf.vue?vue&type=style&index=0&id=5bda32bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports